import { CartAddEvent } from '@theme/events';

function createViewportCenterFlySource() {
  const el = document.createElement('div');
  el.style.cssText =
    'position:fixed;width:72px;height:72px;left:50%;top:50%;transform:translate(-50%,-50%);pointer-events:none;z-index:2;';
  document.body.appendChild(el);
  return el;
}

async function runFlyToCartFromRebuy(imageUrl) {
  console.group(`_debug - runFlyToCartFromRebuy`);
  console.log(`imageUrl: `, imageUrl)
  console.groupEnd();
  const cartIcon = document.querySelector('.header-actions__cart-icon');
  if (!cartIcon) return;

  await customElements.whenDefined('fly-to-cart');
  const sourceEl = createViewportCenterFlySource();

  const flyToCartElement = /** @type {HTMLElement & { source: Element; destination: Element }} */ (
    document.createElement('fly-to-cart')
  );
  flyToCartElement.classList.add('fly-to-cart--rebuy');
  flyToCartElement.style.setProperty('background-image', `url(${imageUrl})`);
  flyToCartElement.style.setProperty('--start-opacity', '0');
  flyToCartElement.source = sourceEl;
  flyToCartElement.destination = cartIcon;
  document.body.appendChild(flyToCartElement);

  requestAnimationFrame(() => {
    setTimeout(() => {
      sourceEl.remove();
    }, 2500);
  });
}

function handleRebuyCartAdd(event) {
  const itemCountStr = document.querySelector('.cart-bubble__text-count')?.innerHTML
  const itemCount = itemCountStr ? parseInt(itemCountStr) + 1 : 1

  document.dispatchEvent(new CartAddEvent({}, 'rebuy-cart-sync', { itemCount }));

  if (!Theme.addToCartAnimation) return;

  const imageUrl = event.detail.product.image?.src
  if (!imageUrl) return;

  try {
    runFlyToCartFromRebuy(imageUrl);
  } catch (error) {
    console.error(error);
  }
}

document.addEventListener('rebuy.add', handleRebuyCartAdd);
